import { useState } from "react";
import {
  HeaderNav,
  HeaderNavButtonHolder,
  HeaderNavContent,
  HeaderNavHamburgerHolder,
  HeaderNavHolder,
  HeaderNavLogo,
  HeaderNavMobileHolder,
} from "../../../styles/reusable/header/headerstyles";
import logo from "./assetes/bugzi logo 2.png";
import { openVsCodeExtension } from "../../../utils/vscodeLauncher";
const HeaderComponent = () => {
  const [openHamburger,setOpenHamburger]= useState<boolean>(false)

  
  return (
    <>
      <HeaderNav>
        <div className="nav-holder">
          <div className="content-holder">
            
            <HeaderNavHolder open={openHamburger}>
              <div className="header-nav-holder-content-holder">
                <HeaderNavLogo>
                  <div>
                    <a href="/" className="header-logo-link-holder">
                      <div className="header-logo-logo ">
                        <div>
                          <img
                            className="logo"
                            src={logo}
                            alt="Bugzi logo"
                          ></img>
                        </div>
                      </div>
                      <div className="header-logo-name ">
                        <p>Bugzi AI</p>
                      </div>
                    </a>
                  </div>
                </HeaderNavLogo>

                <HeaderNavContent  className="header-nav-l">
                  {navLinks.map((item, index) => (
                    <div key={index + "link-item"} className="links-container">
                      <a className="links" href={item.link}>
                        <div>
                          <p className="nav-text">{item.name}</p>
                        </div>{" "}
                      </a>
                    </div>
                  ))}
                </HeaderNavContent>
                <HeaderNavButtonHolder className="header-nav-l">
                  <a href="#" onClick={(e) => { e.preventDefault(); openVsCodeExtension(); }}>
                    <div className="circle" />
                    <div className="top-blur" />
                    <div className="radial-gradient" />
                    <div className="inset" />
                    <div className="button-holder">
                      <div className="button-label">
                        <p className="button-label-text">Get started</p>
                      </div>
                      <div className="button-label-2">
                        <p className="button-label-text">Get started</p>
                      </div>
                    </div>
                  </a>
                </HeaderNavButtonHolder>
                <HeaderNavHamburgerHolder open={openHamburger} onClick={()=>{setOpenHamburger(!openHamburger)}} className="header-nav-hamburger-holder">
                  <div className="bar-holder">
                    <div className="bar bar-1" />
                  </div>
                  <div className="bar-holder">
                    <div className="bar bar-2" />
                  </div>{" "}
                  <div className="bar-holder">
                    <div className="bar bar-3" />
                  </div>
                </HeaderNavHamburgerHolder>
              </div>
              <HeaderNavMobileHolder open={openHamburger}>
 <HeaderNavContent  className="header-nav-m">
                  {navLinks.map((item, index) => (
                    <div key={index + "link-item"} className="links-container">
                      <a className="links" href={item.link}>
                        <div>
                          <p className="nav-text">{item.name}</p>
                        </div>{" "}
                      </a>
                    </div>
                  ))}
                </HeaderNavContent>
                 <HeaderNavButtonHolder className="header-nav-m">
                  <a href="#" onClick={(e) => { e.preventDefault(); openVsCodeExtension(); }}>
                    <div className="circle" />
                    <div className="top-blur" />
                    <div className="radial-gradient" />
                    <div className="inset" />
                    <div className="button-holder">
                      <div className="button-label">
                        <p className="button-label-text">Get started</p>
                      </div>
                      <div className="button-label-2">
                        <p className="button-label-text">Get started</p>
                      </div>
                    </div>
                  </a>
                </HeaderNavButtonHolder>

              </HeaderNavMobileHolder>
             
             
            </HeaderNavHolder>
          </div>
        </div>
      </HeaderNav>
    </>
  );
};

const navLinks = [
  { name: "About us", link: "/about-us" },
  { name: "Pricing", link: "/pricing" },
  { name: "Integration", link: "/Integration" },
  { name: "Blog", link: "/Blog" },
  { name: "contact", link: "/contact" },
];
export default HeaderComponent;
